import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=628e33d2&scoped=true&"
import script from "./Exercises.vue?vue&type=script&lang=js&"
export * from "./Exercises.vue?vue&type=script&lang=js&"
import style0 from "./Exercises.vue?vue&type=style&index=0&id=628e33d2&lang=scss&scoped=true&"
import style1 from "./Exercises.vue?vue&type=style&index=1&id=628e33d2&scoped=true&lang=css&"
import style2 from "./Exercises.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e33d2",
  null
  
)

export default component.exports